import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

export type FaPrefix = 'fas' | 'far' | 'fal' | 'fad' | 'fab' | 'fal';

export interface IFacIcon extends HTMLAttributes<HTMLSpanElement> {
  icon: string;
  iconPrefix?: FaPrefix;
}

const FaIcon: FC<IFacIcon> = (props) => {
  const { iconPrefix = 'fas', icon, className } = props;
  const rootClassName = classNames(iconPrefix, `fa-${icon}`, className);
  return <span className={rootClassName} />;
};

export default FaIcon;
